import { token } from '@atlaskit/tokens';

import { ALIGNMENT, BORDER, CORNERS, type Styles } from '../../types';

const ALIGNMENT_MAP = {
	[ALIGNMENT.LEFT]: 'flex-start',
	[ALIGNMENT.CENTER]: 'center',
	[ALIGNMENT.RIGHT]: 'flex-end',
};

const getBorder = (color: string) => `${token('border.width.selected')} solid ${color}`;

const getBorderStyles = (color: string) => ({
	[BORDER.NONE]: {},
	[BORDER.ALL_SIDES]: { border: getBorder(color) },
	[BORDER.BOTTOM]: {
		borderBottom: getBorder(color),
	},
});

const CORNERS_MAP = {
	[CORNERS.ROUND]: token('radius.small'),
	[CORNERS.SHARP]: 'unset',
};

export const getLinksMenuStyles = (
	styles: Styles,
):
	| {
			backgroundColor: string;
			borderRadius: string;
			justifyContent: string;
	  }
	| {
			backgroundColor: string;
			border: string;
			borderRadius: string;
			justifyContent: string;
	  }
	| {
			backgroundColor: string;
			borderBottom: string;
			borderRadius: string;
			justifyContent: string;
	  } => {
	const { alignment, fillColor, borderColor, border, cornerStyle } = styles;
	return {
		justifyContent: ALIGNMENT_MAP[alignment],
		backgroundColor: fillColor,
		...getBorderStyles(borderColor)[border],
		borderRadius: CORNERS_MAP[cornerStyle],
	};
};
